// extracted by mini-css-extract-plugin
module.exports = {"imgBackground":"Acuerdos__imgBackground__182gG","margin":"Acuerdos__margin__2PRzG"};